import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // 引入 Bootstrap 的 JS 及依赖
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { BrowserRouter } from 'react-router-dom';  // 导入 BrowserRouter
import { message } from 'antd'; // 导入 message
import './styles/antd-override.css'; // 导入 Ant Design 样式覆盖

// React 19 与 Ant Design v6 兼容性标记
if (typeof window !== 'undefined') {
  window.__ANTD_V6_COMPATIBLE__ = true;
}

// 配置全局message
message.config({
  top: 80, // 距离顶部80px（避开导航栏）
  duration: 3, // 默认显示3秒
  maxCount: 3, // 最多同时显示3个消息
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
